import { ShopifyOrderForm } from './types';
import { CartData, CartSdkConfig } from '../../types';

export class ShopifyCart implements CartSdkConfig {
  public async onApplyDiscount(cart: CartData, code: string): Promise<{ success: boolean }> {
    const response = await fetch(`/discount/${code}`, {
      redirect: 'manual',
    });

    return { success: response.ok };
  }

  public async onLoadCart(): Promise<CartData> {
    const response = await fetch('/cart.js', {
      redirect: 'manual',
    });
    const data = await response.json() as ShopifyOrderForm;

    return {
      id: data.token,
      total: data.total_price / 100,
      itemsTotal: data.items_subtotal_price / 100,
      discountCodes: data.cart_level_discount_applications.map((c) => c.title),
      items: [],
    };
  }
}
